import React from "react";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import FormTexts from "../../../constants/forms";
import { formsLabelType } from "../../../enums/index";
// import { ToPersianNumber } from "../../../functions/index";
const PartThree = (props) => {
  return (
    <>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.CompanyName())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.CompanyName ? props.customer.CompanyName : ""}
            onChange={() => console.log("")}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Occupation())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={
              props.customer.BusinessField ? props.customer.BusinessField : ""
            }
            onChange={() => console.log("")}
          />
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.CodeNumber())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={
              props.customer.CompanyRegistrationNumber
                ? props.customer.CompanyRegistrationNumber
                : ""
            }
            onChange={() => console.log("")}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.CompanyNationalCode())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={
              props.customer.NationalCompanyRegistrationNumber
                ? props.customer.NationalCompanyRegistrationNumber
                : ""
            }
            onChange={() => console.log("")}
          />
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.CompanyEconomicCode())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={props.customer.EconomicCode ? props.customer.EconomicCode : ""}
            onChange={() => console.log("")}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.PostalCode())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={
              props.customer.WorkPostalCode ? props.customer.WorkPostalCode : ""
            }
            onChange={() => console.log("")}
          />
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.CompanyAddress())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            rows={3}
            as="textarea"
            value={props.customer.WorkAddress ? props.customer.WorkAddress : ""}
            onChange={() => console.log("")}
          />
        </Form.Group>
      </Row>
    </>
  );
};
export default PartThree;
